import type { HeadToHeadSearch, TeamHistorySearch } from './search-schema'
import { footballCoreHref } from '~/lib/navigation/football-core'

export function teamHistoryHref(locale: string, teamId: string, search: TeamHistorySearch): string {
  const query = new URLSearchParams()
  if (search.competition !== undefined && search.season !== undefined) {
    query.set('competition', search.competition)
    query.set('season', String(search.season))
  }
  if (search.from !== undefined)
    query.set('from', search.from)
  if (search.to !== undefined)
    query.set('to', search.to)
  if (search.page > 1)
    query.set('page', String(search.page))
  return footballCoreHref(locale, `/teams/${encodeURIComponent(teamId)}/history`, {
    query,
    back: search.back,
  })
}

export function historicalMatchHref(locale: string, historicalMatchId: string, back: string): string {
  return footballCoreHref(locale, `/history/matches/${encodeURIComponent(historicalMatchId)}`, { back })
}

export function canonicalMatchHref(locale: string, matchId: string, back: string): string {
  return footballCoreHref(locale, `/matches/${encodeURIComponent(matchId)}`, { back })
}

export function headToHeadHref(locale: string, search: HeadToHeadSearch): string {
  const query = new URLSearchParams()
  query.set('teamA', search.teamA)
  query.set('teamB', search.teamB)
  if (search.competition !== undefined && search.season !== undefined) {
    query.set('competition', search.competition)
    query.set('season', String(search.season))
  }
  if (search.from !== undefined)
    query.set('from', search.from)
  if (search.to !== undefined)
    query.set('to', search.to)
  if (search.page > 1)
    query.set('page', String(search.page))
  return footballCoreHref(locale, '/teams/compare', {
    query,
    back: search.back,
  })
}
